// Only the top-level API array represents persisted ownership.
// Scanner detail/additionalData and scalar aliases are never promoted into this contract.
export function persistedFindingAssetIds(finding) {
  const value = finding?.affectedAssetIds ?? finding?.AffectedAssetIds;
  if (!Array.isArray(value)) return null;
  // A malformed array is present but cannot prove any ownership.
  if (!value.every(id => typeof id === 'string' && id.trim())) return [];
  return [...new Set(value.map(id => id.trim().toLowerCase()))];
}
